<template>
  <div class="about">
    <!-- 3-1 英雄総選挙とは -->
    <section class="introduction">
      <h2 class="title" v-html="$t('text001')" />
      <p v-html="$t('text002')" />
      <img class="charactors" :src="require('@images/about/heroes/charactors.png')">
      <vote-notice class="notice"/>
    </section>
    <section class="special-gift">
      <h2 v-html="$t('text003')" />
      <img class="wallpaper" :src="wallpaperImage">
      <h2 v-html="$t('text004')" />
      <p class="notes">
        {{ $t('text005') }}<br>
        {{ $t('text006') }}
      </p>
      <div class="coin">
        <img src="@images/about/coin.png">
        <p>
          <span v-html="$t('text007')" /><br>
          <span class="value" v-html="$t('text008')" />
        </p>
      </div>
    </section>
    <section class="history">
      <history-item
        v-for="(item, index) in historyItems"
        :key="index"
        class="item"
        :count="index + 1"
        :title="item.title"
        :url="item.url"
      />
    </section>
  </div>
</template>

<script>
import VoteNotice from '@components/global/vote-notice.vue'
import HistoryItem from '@components/about/history-item.vue'
import localeAbout from '@locales/about'

export default {
  name: 'about',
  $messages: localeAbout,
  components: {
    VoteNotice,
    HistoryItem,
  },
  computed: {
    historyItems() {
      return [
        {
          title: this.$t('text009'),
          url: 'https://events.fire-emblem-heroes.com/vote/result'
        },
        {
          title: this.$t('text010'),
          url: 'https://events.fire-emblem-heroes.com/vote2/result'
        },
        {
          title: this.$t('text011'),
          url: 'https://vote3.campaigns.fire-emblem-heroes.com/results'
        },
      ]
    },
    wallpaperImage() {
      return this.$route.params.lang === 'ja-JP' ? require('@images/about/wallpaper_jp.png') : require('@images/about/wallpaper.png')
    },
  }
}
</script>

<style lang="scss" scoped>
.about {
  .pre-wrap {
    white-space: pre-wrap;
  }
  h2 {
    font-size: $fs-base * 1.5;
  }
  > .introduction {
    margin-top: 40px;
    > *:not(.notice) {
      text-align: center;
      text-shadow: $ts-base;
    }
    .title {
      margin-bottom: 20px;
    }
    .charactors {
      margin-top: 20px;
    }
  }
  > .special-gift {
    margin-top: 60px;
    text-align: center;
    text-shadow: $ts-base;
    background-image: url(#{$img-path}about/bg_spacial.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: 50% 10%;
    .wallpaper {
      margin: 80px 0;
    }
    .notes {
      margin: 30px 0;
    }
    .coin {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 450px;
      margin: 0 auto;
      .value {
        font-size: $fs-large * 2;
      }
      > *:last-child {
        flex-grow: 1;
        text-align: left;
        margin-left: 40px;
      }
    }
  }
  > .history {
    margin-top: 60px;
    .item {
      margin-top: 40px;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
